import React, { useMemo } from 'react';
import { useField } from 'react-final-form';

import { useDocumentColors } from '@wp-block-builder/package';

import RawColorPickerInput from '../raw/RawColorPickerInput';

type Props = {
  label: string;
  name: string;
};
export default function Border({ label, name }: Props) {
  const { input } = useField(name);
  const secondarySwatch = useDocumentColors();
  const onChange = (value: string | null) => {
    if (value === null || value.trim().length === 0) {
      input.onChange(null);
      return;
    }
    input.onChange(`1px solid ${value}`);
  };
  const value = useMemo(() => {
    if (typeof input.value !== 'string') {
      return '';
    }
    const m = input.value.match(/^1px solid (#[A-Fa-f0-9]{6})$/);
    if (m) {
      return m[1];
    }
    return '';
  }, [input]);

  return (
    <RawColorPickerInput
      {...{
        label,
        onChange,
        value,
        secondarySwatch,
      }}
    />
  );
}
